import { BatchDocuments as SharedBatchDocuments } from '@griply/services';
import { DocumentReference, Firestore, writeBatch } from 'firebase/firestore';

export class BatchDocuments extends SharedBatchDocuments<
  DocumentReference,
  Firestore
> {
  constructor(database: Firestore) {
    super(database, writeBatch);
  }
}
